/**
 * Chars that TTS does not reliably convey in dictation — shown in gray before
 * typing so the learner knows to enter them. User still types every character.
 */
export function isDictationAudioHintChar(ch: string): boolean {
  if (ch.length !== 1) return false;
  if (ch === ch.toUpperCase() && ch !== ch.toLowerCase()) return true;
  return /[.!?;:,\-@]/.test(ch);
}
